function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Toggle } from '@keen.io/ui-core';
import SettingsItem from '../../../SettingsItem';
import SectionTitle from '../../../SectionTitle';
import Label from '../../../Label';
import Row from '../../../Row';

var FunnelSettings = function FunnelSettings(_ref) {
  var chartSettings = _ref.chartSettings,
      widgetSettings = _ref.widgetSettings,
      onUpdateWidgetSettings = _ref.onUpdateWidgetSettings,
      onUpdateChartSettings = _ref.onUpdateChartSettings,
      hiddenOptions = _ref.hiddenOptions;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var funnelPercentages = chartSettings.funnelPercentages;
  return React.createElement("div", null, React.createElement(SectionTitle, {
    title: t('widget_customization_funnel_settings.title')
  }), !(hiddenOptions === null || hiddenOptions === void 0 ? void 0 : hiddenOptions.card) && React.createElement(SettingsItem, {
    id: "funnel-card",
    label: t('widget_customization_card_settings.label'),
    isEnabled: widgetSettings.card.enabled,
    onChange: function onChange(cardEnabled) {
      onUpdateWidgetSettings(_objectSpread(_objectSpread({}, widgetSettings), {}, {
        card: _objectSpread(_objectSpread({}, widgetSettings.card), {}, {
          enabled: cardEnabled
        })
      }));
    }
  }), React.createElement(Row, {
    "data-testid": "funnel-percentages"
  }, React.createElement(Label, null, t('widget_customization_funnel_settings.percentages')), React.createElement(Toggle, {
    isOn: funnelPercentages,
    onChange: function onChange(percentagesEnabled) {
      return onUpdateChartSettings(_objectSpread(_objectSpread({}, chartSettings), {}, {
        funnelPercentages: percentagesEnabled
      }));
    }
  })));
};

export default FunnelSettings;